import * as React from 'react';
import {authorize} from "@athena-portal/components";
import FalconHeader from "../components/navigation/FalconHeader";
import FalconFooter from "../components/navigation/FalconFooter";

interface IState {
    accountUrl: string,
    redirectUrl: string,
}

@authorize
export class AllianzPromotionPage extends React.Component<{}, IState> {

    constructor(props: {}) {
        super(props);

        this.state = {
            accountUrl: '/dashboard',
            redirectUrl: '/dashboard'
        }
    }

    public render() {
        return (
            <React.Fragment>
                <FalconHeader />
                <div className="home-promotion-page">
                    <div className="confetti-background">
                        <div className="heading">
                            <h1 className="font-weight-light">Introducing</h1>
                            <img src="/img/allianz-advantages-logo.svg" alt="allianz-advantages" className="allianz-advantages-main-logo"/>

                            <div className="d-flex flex-column align-items-start justify-content-start subheading-section">
                                <div className="button-container">
                                    <button type="button" className="btn btn-primary allianz-promo-btn"
                                            onClick={() => this.redirectToAdvantages()}>
                                        Check it out!
                                    </button>

                                    <button type="button" className="btn btn-white allianz-promo-btn allianz-promo-btn-right"
                                            onClick={() => this.redirect(this.state.redirectUrl)}>
                                        Maybe later
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="page-content-container">
                        <div className="page-content">
                            <p className="page-content-heading">What will I find?</p>
                            <div className="info-sections text-content">
                                <div className="left-section home-promotion-list">
                                    <div className="bullet-section">
                                        <img src="/img/tick-bulletpoint.svg" alt="Tick" className="tick-image"/>
                                        <div>
                                            <p><b>Offers and discounts just for you.</b></p>
                                        </div>
                                    </div>

                                    <div className="bullet-section">
                                        <img src="/img/tick-bulletpoint.svg" alt="Tick" className="tick-image"/>
                                        <div>
                                            <p><b>Your chance to win fantastic prizes.</b></p>
                                        </div>
                                    </div>

                                    <div className="bullet-section">
                                        <img src="/img/tick-bulletpoint.svg" alt="Tick" className="tick-image"/>
                                        <div>
                                            <p><b>Exclusive rewards and giveaways for our rugby fans, including tickets to Allianz Stadium – the Home of England Rugby.</b>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <FalconFooter />
            </React.Fragment>
        );
    }

    private redirectToAdvantages = () => {
        this.redirect("dashboard/advantages");
    }

    private redirect = (redirectUrl: string) => {
        window.location.assign(redirectUrl)
    }
}
